<template>
  <div class="toast-global-container position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 1100"></div>
  <router-view />
</template>

<script>
import { startGlobalPolling, stopGlobalPolling } from '@/utils/chatStore'
export default {
  name: 'App',
 mounted() {
    const supplierId = localStorage.getItem('supplier_id')
    if (supplierId) {
      startGlobalPolling(Number(supplierId), () => this.$route.name === 'Conversations' ? this.activeConversationId : null)
    }
  },
  beforeUnmount() {
    stopGlobalPolling()
  },
}
</script>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;

}

/* body *{
font-family:  Helvetica !important;
} */

/* Remove the margin-top that was pushing everything down */
#app,
#app-root {
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Scoped styles with !important where needed */
:root {
  --color-primary: #0c1253;
  --color-secondary: #0b1799;
  --color-tint-warm: #EC993A;
  --color-tint-light: #FFF0E4;
  --color-surface: #ffffff;
  --color-border: #f0e6e8;
  --color-text-muted: #9a8a9e;
  --color-text-dark: #34133c;
  --color-bg: #f6f3f3;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 4px 2px 16px;
  margin-bottom: 4px;
}

.page-header__titles {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

/* accent bar next to the title, ties the header to the same purple/plum
   identity used by the table's glass panels */
.page-header__accent {
  width: 5px;
  height: 28px;
  border-radius: 999px;
  background: linear-gradient(180deg, var(--color-primary), var(--color-secondary));
  flex-shrink: 0;
}

.page-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--color-text-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-header__subtitle {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--color-text-muted);
}

.page-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-page-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 18px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(145deg, var(--color-primary), var(--color-secondary));
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 22px -10px rgba(93, 28, 106, 0.5);
  transition: transform 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease;
}

.btn-page-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px -10px rgba(93, 28, 106, 0.55);
  filter: brightness(1.03);
}

.btn-page-primary:active {
  transform: translateY(0);
}

.btn-page-primary i,
.btn-page-primary .material-symbols-outlined {
  font-size: 15px;
}

/* Secondary / outline action next to the CTA */
.btn-page-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text-dark);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}

.btn-page-secondary:hover {
  background: var(--color-tint-light);
}

a {
  text-decoration: none;
}


/* ///profile page */
.asp-page {
  width: 100%;
  background: var(--color-bg);
}

.asp-page * {
  box-sizing: border-box;
}

.asp-status {
  padding: 80px 24px;
  text-align: center;
  font-size: 13.5px;
  color: var(--color-text-muted);
}

.asp-status--error {
  color: #b3261e;
}

/* Topbar */
.asp-topbar {
  background: var(--color-primary);
  padding: 16px 28px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.asp-back {
  flex-shrink: 0;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: #e4e0ea;
  padding: 7px 14px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s ease;
}

.asp-back:hover {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.asp-topbar__identity {
  display: flex;
  align-items: center;
  gap: 14px;
}

.asp-topbar__avatar {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  background: linear-gradient(145deg, var(--color-secondary), var(--color-tint-warm));
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  overflow: hidden;
}

.asp-topbar__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asp-topbar__name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.asp-topbar__name {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
}

.asp-topbar__meta {
  margin: 2px 0 0;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.65);
}

/* Body */
.asp-body {
  max-width: 1240px;
  margin: 0 auto;
  padding: 22px 20px 60px;
}

/* Horizontal tabs */
.asp-tabs {
  display: flex;
  gap: 4px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 6px;
  margin-bottom: 20px;
  overflow-x: auto;
}

.asp-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border: none;
  background: transparent;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-muted);
  cursor: pointer;
  border-radius: 7px;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease;
}

.asp-tab:hover {
  background: var(--color-tint-light);
  color: var(--color-text-dark);
}

.asp-tab.is-active {
  background: var(--color-primary);
  color: #fff;
}

.asp-tab__icon {
  font-size: 14px;
}

.asp-tab__count {
  font-size: 10px;
  font-weight: 700;
  background: rgba(52, 19, 60, 0.08);
  color: var(--color-text-muted);
  padding: 1px 7px;
  border-radius: 999px;
}

.asp-tab.is-active .asp-tab__count {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.asp-content {
  min-width: 0;
}

.asp-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.asp-stats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 4px;
}

.asp-stat {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.asp-stat strong {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-primary);
}

.asp-stat span {
  font-size: 10.5px;
  color: var(--color-text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.asp-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 18px 20px;
}

.asp-card__title {
  margin: 0 0 14px;
  font-size: 13px;
  font-weight: 700;
  color: var(--color-text-dark);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.asp-card__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.asp-card__title-row .asp-card__title {
  margin: 0;
}

.asp-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.asp-kv {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid var(--color-border);
  font-size: 12.5px;
}

.asp-kv:last-child {
  border-bottom: none;
}

.asp-kv span {
  color: var(--color-text-muted);
  flex-shrink: 0;
}

.asp-kv strong {
  color: var(--color-text-dark);
  font-weight: 600;
  text-align: right;
}

.asp-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.asp-type-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: var(--color-tint-light);
  border: 1px solid var(--color-border);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-dark);
}

.asp-note {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

.asp-empty {
  margin: 0;
  font-size: 12.5px;
  color: var(--color-text-muted);
  padding: 6px 0;
}

.asp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}

.asp-table thead th {
  text-align: left;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted);
  padding: 0 10px 8px;
  border-bottom: 1px solid var(--color-border);
}

.asp-table tbody td {
  padding: 10px;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-dark);
  vertical-align: top;
}

.asp-table tbody tr:last-child td {
  border-bottom: none;
}

.asp-table tbody tr:hover td {
  background: var(--color-tint-light);
}

.asp-col-num {
  width: 28px;
  color: var(--color-text-muted);
  font-weight: 600;
}

.asp-col-answer {
  width: 90px;
}

.asp-td-strong {
  font-weight: 700;
}

.asp-td-muted {
  color: var(--color-text-muted);
}

.asp-link {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-secondary);
  text-decoration: none;
}

.asp-link:hover {
  text-decoration: underline;
}

.asp-yn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 8px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
}

.asp-yn--yes {
  background: #1a7f4b;
}

.asp-yn--no {
  background: #b3261e;
}

.asp-yn--na {
  background: var(--color-text-muted);
}

.asp-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.asp-detail-item strong {
  font-size: 0.75rem;
  color: var(--color-text-dark);
  font-weight: 600;
}

.asp-detail-item span {
  color: var(--color-text-muted);
  word-break: break-word;
}

.asp-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
}

.asp-status-badge--sm {
  padding: 1px 7px;
  font-size: 9.5px;
}

.asp-status-badge--approved {
  background: rgba(26, 127, 75, 0.12);
  color: #1a7f4b;
  border: 1px solid rgba(26, 127, 75, 0.3);
}

.asp-status-badge--pending {
  background: rgba(236, 153, 58, 0.16);
  color: #b5670f;
  border: 1px solid rgba(236, 153, 58, 0.4);
}

.asp-status-badge--rejected {
  background: rgba(179, 38, 30, 0.1);
  color: #b3261e;
  border: 1px solid rgba(179, 38, 30, 0.3);
}

.asp-status-badge--neutral {
  background: var(--color-tint-light);
  color: var(--color-text-muted);
  border: 1px solid var(--color-border);
}

@media (max-width: 960px) {
  .asp-grid-2 {
    grid-template-columns: 1fr;
  }

  .asp-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

.asp-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.asp-topbar__identity {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 0;
  flex: 1;
}

.asp-back {
  margin-left: auto;
  flex-shrink: 0;
}


.my-supplier-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text-dark);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, opacity 0.18s ease;
}

.my-supplier-btn:hover:not(:disabled) {
  background: var(--color-tint-light);
  border-color: var(--color-secondary);
}

.my-supplier-btn:disabled {
  cursor: not-allowed;
}

.my-supplier-btn--none {
  background: linear-gradient(145deg, var(--color-primary), var(--color-secondary));
  color: #fff;
  border-color: transparent;
}

.my-supplier-btn--none:hover:not(:disabled) {
  opacity: 0.92;
  color: var(--color-primary);
}

.my-supplier-btn--pending {
  color: #a15b0a;
  background: rgba(236, 153, 58, 0.12);
  border-color: rgba(236, 153, 58, 0.3);
  opacity: 0.9;
}

.my-supplier-btn--approved {
  color: #1a7f4b;
  background: rgba(26, 127, 75, 0.1);
  border-color: rgba(26, 127, 75, 0.3);
  opacity: 0.9;
}

.my-supplier-btn--rejected {
  color: #b3261e;
  background: rgba(179, 38, 30, 0.08);
  border-color: rgba(179, 38, 30, 0.25);
  opacity: 0.9;
}
.supplier-reviews{
      margin-top: 2rem;
    border-top: 3px solid var( --color-tint-warm);
    border-left: 2px solid var( --color-tint-warm);
    border-radius: 37px;
    padding: 10px 34px;
}
/* ========== Reviews Tab ========== */
.reviews-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.reviews-stats {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.reviews-stats__average {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.reviews-stats__stars {
  display: flex;
  gap: 2px;
  font-size: 18px;
  color: #d1d5db;
}

.reviews-stats__stars .star--filled {
  color: #f59e0b;
}

.reviews-stats__number {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text-dark);
}

.reviews-stats__count {
  font-size: 14px;
  color: var(--color-text-muted);
}

/* Rating Distribution */
.rating-distribution {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--color-tint-light);
  border-radius: 8px;
}

.rating-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.25rem 0;
}

.rating-bar__label {
  width: 45px;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-dark);
  flex-shrink: 0;
}

.rating-bar__track {
  flex: 1;
  height: 8px;
  background: var(--color-border);
  border-radius: 4px;
  overflow: hidden;
}

.rating-bar__fill {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
  border-radius: 4px;
  transition: width 0.6s ease;
}

.rating-bar__count {
  width: 30px;
  font-size: 13px;
  color: var(--color-text-muted);
  text-align: right;
  flex-shrink: 0;
}

/* Reviews List */
.reviews-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.review-item {
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  background: var(--color-surface);
  transition: box-shadow 0.2s;
}

.review-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.review-item__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.review-item__identity {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.review-item__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(145deg, var(--color-primary), var(--color-secondary));
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  overflow: hidden;
}

.review-item__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.review-item__name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-dark);
}

.review-item__date {
  display: block;
  font-size: 11px;
  color: var(--color-text-muted);
}

.review-item__stars {
  display: flex;
  gap: 2px;
  font-size: 16px;
  color: #d1d5db;
  flex-shrink: 0;
}

.review-item__stars .star--filled {
  color: #f59e0b;
}

.review-item__content {
  margin: 0 0 0.5rem;
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-dark);
  white-space: pre-wrap;
  word-break: break-word;
}

.review-item__comments {
  margin: 0 0 0.5rem;
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text-muted);
  font-style: italic;
}

.review-item__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--color-border);
}

.review-item__status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
}

.review-item__status--approved {
  background: rgba(26, 127, 75, 0.12);
  color: #1a7f4b;
}

.review-item__status--pending {
  background: #fef3c7;
  color: #92400e;
}

.review-item__status--rejected {
  background: rgba(179, 38, 30, 0.1);
  color: #b3261e;
}

.review-item__id {
  font-size: 11px;
  color: var(--color-text-muted);
}

/* Empty State */
.reviews-empty {
  text-align: center;
  padding: 2rem 1rem;
}

.reviews-empty__icon {
  display: block;
  font-size: 48px;
  margin-bottom: 0.75rem;
}

.reviews-empty__text {
  margin: 0 0 0.25rem;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-dark);
}

.reviews-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--color-text-muted);
}

/* Responsive */
@media (max-width: 640px) {
  .reviews-header {
    flex-direction: column;
    align-items: stretch;
  }

  .reviews-stats {
    justify-content: flex-start;
  }

  .review-item__header {
    flex-direction: column;
    align-items: stretch;
  }

  .review-item__stars {
    align-self: flex-start;
  }

  .review-item__footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}



/* ////signup page */
.supplier-signup__page {
  background: linear-gradient(180deg, var(--color-tint-light) 0%, var(--color-surface) 320px);
  padding: 48px 20px 64px;
}

.hero {
  margin: 0 auto 36px;
  text-align: center;
}

.hero__eyebrow {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-secondary);
  margin-bottom: 12px;
}

.hero__title {
  margin: 0 0 12px;
  font-size: 30px;
  line-height: 1.2;
  font-weight: 800;
  color: var(--color-text-dark);
}

.hero__subtitle {
  margin: 0 0 20px;
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--color-text-muted);
}

.hero__points {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 20px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--color-text-dark);
}
.hero__points li {
  display: flex;
  align-items: center;
  gap: 6px;
}
.hero__check {
  color: var(--color-tint-warm);
  font-weight: 800;
}

.supplier-signup__container {
  max-width: 980px;
  margin: 0 auto;
}

.supplier-signup__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px;
  text-align: center;
  color: var(--color-text-muted);
}
.loading-spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2.5px solid var(--color-border);
  border-top-color: var(--color-secondary);
  animation: supplier-spin 0.7s linear infinite;
}
@keyframes supplier-spin {
  to { transform: rotate(360deg); }
}

.supplier-signup__top-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(179, 38, 30, 0.07);
  border: 1px solid rgba(179, 38, 30, 0.24);
  font-size: 13.5px;
  animation: shake-error 0.4s ease;
}
@keyframes shake-error {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-3px); }
  80% { transform: translateX(3px); }
}
.section-block {
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid var(--color-border);
  border-radius: 20px;
  padding: 26px 28px;
  margin: 0 0 22px;
  box-shadow: 0 4px 18px -12px rgba(12, 18, 83, 0.14);
  transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease;
  animation: section-fade-in 0.4s ease;
}
@keyframes section-fade-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
.section-block:hover {
  box-shadow: 0 10px 28px -14px rgba(12, 18, 83, 0.22);
}

.section-block--types           { border-left: 5px solid #0b1799; border-top: 1px solid #0b1799; }
.section-block--company         { border-left: 5px solid #0b1799; border-top: 1px solid #0b1799; }
.section-block--manufacturing   { border-left: 5px solid #ec993a; border-top: 1px solid #ec993a; }
.section-block--production      { border-left: 5px solid #1a7f4b; border-top: 1px solid #1a7f4b; }
.section-block--poc             { border-left: 5px solid #ca5995; border-top: 1px solid #ca5995; }
.section-block--qa              { border-left: 5px solid #2a9d8f; border-top: 1px solid #2a9d8f; }
.section-block--compliance      { border-left: 5px solid #b3261e; border-top: 1px solid #b3261e; }
.section-block--ipcert          { border-left: 5px solid #3ba55d; border-top: 1px solid #3ba55d; }
.section-block--foodsafety      { border-left: 5px solid #6b5ce7; border-top: 1px solid #6b5ce7; }
.section-block--services        { border-left: 5px solid #e07a5f; border-top: 1px solid #e07a5f; }
.section-block--materials       { border-left: 5px solid #457b9d; border-top: 1px solid #457b9d; }
.section-block--products        { border-left: 5px solid #d1495b; border-top: 1px solid #d1495b; }
.section-block--comments        { border-left: 5px solid #6c757d; border-top: 1px solid #6c757d; }

.section-block--has-error {
  border-left-color: #b3261e !important;
  box-shadow: 0 0 0 2px rgba(179, 38, 30, 0.16), 0 10px 26px -14px rgba(179, 38, 30, 0.24);
  animation: error-pulse 1.4s ease-in-out 1;
}
@keyframes error-pulse {
  0% { box-shadow: 0 0 0 0 rgba(179, 38, 30, 0.35); }
  70% { box-shadow: 0 0 0 8px rgba(179, 38, 30, 0); }
  100% { box-shadow: 0 0 0 0 rgba(179, 38, 30, 0); }
}

/* ---------- Section headers ---------- */
.section-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin: 0 0 18px;
}

.section-head__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--color-tint-light);
  display: grid;
  place-items: center;
  font-size: 19px;
  box-shadow: inset 0 0 0 1px var(--color-border);
}

.section-head__title {
  margin: 0 0 2px;
  font-size: 15.5px;
  font-weight: 800;
  color: var(--color-text-dark);
}

.section-head__desc {
  margin: 0;
  font-size: 12.5px;
  color: var(--color-text-muted);
}

.section-head__tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.section-head__tag--manufacturing { background: rgba(236, 153, 58, 0.12); border: 1px solid rgba(236, 153, 58, 0.35); color: #b5670f; }
.section-head__tag--production    { background: rgba(26, 127, 75, 0.1);   border: 1px solid rgba(26, 127, 75, 0.3);  color: #1a7f4b; }
.section-head__tag--services      { background: rgba(224, 122, 95, 0.12); border: 1px solid rgba(224, 122, 95, 0.35); color: #b8492f; }
.section-head__tag--materials     { background: rgba(69, 123, 157, 0.12); border: 1px solid rgba(69, 123, 157, 0.35); color: #2d5773; }
.section-head__tag--products      { background: rgba(209, 73, 91, 0.12);  border: 1px solid rgba(209, 73, 91, 0.35);  color: #a5293d; }

/* Sub-headers used inside a section-block (e.g. non-cert questionnaire nested under Food Safety) */
.section-subhead {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 20px 0 14px;
  padding-top: 18px;
  border-top: 1px dashed var(--color-border);
}
.section-subhead__icon {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: var(--color-tint-light);
  display: grid;
  place-items: center;
  font-size: 14px;
}
.section-subhead__title {
  margin: 0 0 1px;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--color-text-dark);
}
.section-subhead__desc {
  margin: 0;
  font-size: 11.5px;
  color: var(--color-text-muted);
}

/* ==========================================================================
   Type selector cards
   ========================================================================== */
.type-select {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 4px;
}

.type-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 18px 16px;
  border-radius: 16px;
  border: 1.5px solid var(--color-border);
  background: var(--color-surface);
  cursor: pointer;
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}
.type-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px -14px rgba(12, 18, 83, 0.25);
}
.type-card__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.type-card__icon {
  font-size: 22px;
  margin-bottom: 4px;
}
.type-card__label {
  font-size: 14.5px;
  font-weight: 700;
  color: var(--color-text-dark);
}
.type-card__desc {
  font-size: 12px;
  color: var(--color-text-muted);
  line-height: 1.4;
}
.type-card.is-active {
  border-color: transparent;
  background: linear-gradient(160deg, rgba(11, 23, 153, 0.06), rgba(236, 153, 58, 0.08));
  box-shadow: 0 0 0 2px var(--color-secondary), 0 12px 26px -14px rgba(12, 18, 83, 0.35);
}
.type-card.is-active .type-card__label::after {
  content: ' ✓';
  color: var(--color-secondary);
}

/* ==========================================================================
   Questionnaire rows
   ========================================================================== */
.q-row {
  display: flex;
  gap: 12px;
  padding: 14px 6px;
  border-bottom: 1px solid var(--color-border);
  border-radius: 8px;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.q-row:last-child {
  border-bottom: none;
}
.q-row--error {
  background: rgba(179, 38, 30, 0.05);
  border-left: 2px solid #b3261e;
  padding-left: 10px;
}
.q-row--error .q-text {
  font-weight: 600;
}

.q-num {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: var(--color-tint-light);
  color: var(--color-text-dark);
  font-size: 12px;
  font-weight: 700;
  display: grid;
  place-items: center;
}
.q-content {
  flex: 1;
  min-width: 0;
}
.q-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.q-text {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--color-text-dark);
  flex: 1;
  min-width: 220px;
}
.q-sub {
  margin: 8px 0 0;
  padding-left: 18px;
  color: var(--color-text-muted);
  font-size: 12.5px;
}
.q-sub li {
  margin-bottom: 2px;
}
.yn-group {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.yn-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: var(--color-text-muted);
  background: var(--color-surface);
  transition: background 0.15s ease, border-color 0.15s ease;
}
.yn-label input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.yn-label:has(input:checked) {
  color: #fff;
  border-color: transparent;
}
.yn-yes:has(input:checked) { background: #1a7f4b; }
.yn-no:has(input:checked) { background: #b3261e; }
.yn-na:has(input:checked) { background: var(--color-text-muted); }

/* ==========================================================================
   IP certs grid
   ========================================================================== */
.ip-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}
.ip-item {
  padding: 12px;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  transition: border-color 0.15s ease;
}
.ip-item:hover {
  border-color: var(--color-secondary);
}
.ip-file-zone {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ==========================================================================
   Food safety cert cards
   ========================================================================== */
.cert-card {
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
  margin-top :10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.cert-card--error {
  border-color: rgba(179, 38, 30, 0.4);
  box-shadow: 0 0 0 2px rgba(179, 38, 30, 0.12);
}
.cert-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: var(--color-text-dark);
}

/* ==========================================================================
   Draft entry cards for Materials / Products
   ========================================================================== */
.draft-card {
  background: rgba(255, 255, 255, 0.55);
  border: 1.5px dashed var(--color-border);
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 18px;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.draft-card--editing {
  border-style: solid;
  border-color: var(--color-secondary);
  background: rgba(236, 153, 58, 0.05);
}
.draft-card__label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(236, 153, 58, 0.12);
  color: #b5670f;
  font-size: 12.5px;
  font-weight: 700;
}
.draft-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

/* Added items table */
.added-table-wrap {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid var(--color-border);
  margin-bottom: 8px;
}
.added-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.added-table thead th {
  text-align: left;
  padding: 11px 14px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted);
  background: var(--color-tint-light);
  border-bottom: 1px solid var(--color-border);
}
.added-table__actions-col {
  width: 96px;
  text-align: right !important;
}
.added-table tbody td {
  padding: 11px 14px;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-text-dark);
  vertical-align: middle;
}
.added-table tbody tr:last-child td {
  border-bottom: none;
}
.added-table tbody tr {
  transition: background 0.15s ease;
}
.added-table tbody tr:hover td {
  background: var(--color-tint-light);
}
.added-table tbody tr.is-editing td {
  background: rgba(236, 153, 58, 0.1);
}
.added-table__strong {
  font-weight: 700;
}
.added-table__actions {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
.table-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text-muted);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.table-icon-btn:hover {
  background: var(--color-tint-light);
  color: var(--color-text-dark);
  transform: translateY(-1px);
}
.table-icon-btn--danger:hover {
  background: rgba(179, 38, 30, 0.1);
  color: #b3261e;
}

@media (max-width: 760px) {
  .added-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
.rform__btn--add {
  height: 35px;
  padding: 0 22px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(145deg, var(--color-primary), var(--color-secondary));
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow: 0 8px 22px -10px rgba(93, 28, 106, 0.5);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.rform__btn--add:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px -10px rgba(93, 28, 106, 0.62);
  filter: brightness(1.04);
}
.rform__btn--add:active {
  transform: scale(0.97);
}
.rform__btn-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.rform__btn--add-sm {
  height: 35px;
  padding: 0 16px;
  font-size: 13px;
  border-radius: 11px;
  margin-top: 5px;
}
:deep(.rform__actions .rform__btn--primary) {
  min-width: 220px;
  font-size: 14.5px;
  box-shadow: 0 10px 26px -10px rgba(93, 28, 106, 0.55);
}
:deep(.rform__actions .rform__btn--primary:hover) {
  box-shadow: 0 14px 32px -10px rgba(93, 28, 106, 0.65);
  transform: translateY(-2px);
}

.supplier-signup__extra-row {
  align-items: end;
}
.supplier-signup__remove-btn {
  height: 34px;
  padding: 0 14px;
  align-self: end;
}
.supplier-signup__remarks {
  margin-top: 4px;
}
.supplier-signup__details-row {
  margin-top: 4px;
}
.supplier-signup__intro {
  margin-top: -4px;
}

.rform__service-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.rform__service-row .rform__field {
  flex: 1;
  min-width: 180px;
}
.rform__service-row .rform__remove-btn {
  flex-shrink: 0;
}

.login-card__signup {
  text-align: center;
  margin-top: 1.5rem;
}
.login-card__signup-link {
  color: var(--color-secondary, #0d6efd);
  text-decoration: underline;
  font-weight: 600;
}
.login-card__signup-link:hover {
  filter: brightness(0.9);
}

@media (max-width: 640px) {
  .hero__title {
    font-size: 24px;
  }
  .type-select {
    grid-template-columns: 1fr;
  }
  .section-block {
    padding: 20px 16px;
  }
}
/* Document styles */
.asp-td-documents {
  position: relative;
  min-width: 80px;
}

.document-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.document-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-primary, #6c2bd9);
  text-decoration: none;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.document-link:hover {
  background-color: rgba(108, 43, 217, 0.08);
  text-decoration: underline;
}

.document-link svg {
  flex-shrink: 0;
}

/* Compact document count with tooltip */
.document-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.document-count {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--color-primary-light, #f0ebff);
  color: var(--color-primary, #6c2bd9);
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.document-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
  padding: 8px;
  min-width: 180px;
  max-width: 280px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 100;
  pointer-events: none;
}

.document-wrapper:hover .document-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-4px);
  pointer-events: auto;
}

.doc-tooltip-item {
  padding: 4px 0;
}

.doc-tooltip-item:not(:last-child) {
  border-bottom: 1px solid var(--color-border, #e5e7eb);
}

.doc-tooltip-link {
  display: block;
  color: var(--color-text, #1f2937);
  text-decoration: none;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.15s;
}

.doc-tooltip-link:hover {
  background: var(--color-tint-light, #f3f4f6);
  color: var(--color-primary, #6c2bd9);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .asp-table {
    display: block;
    overflow-x: auto;
  }
  
  .asp-td-documents {
    min-width: 100px;
  }
  
  .document-link {
    font-size: 11px;
    padding: 2px 6px;
  }
  
  .document-tooltip {
    min-width: 140px;
    max-width: 200px;
    left: 0;
    transform: translateX(0) translateY(-8px);
  }
  
  .document-wrapper:hover .document-tooltip {
    transform: translateX(0) translateY(-4px);
  }
}
.asp-cell-wrap {
  max-width: 220px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>